import { getSubstrateResourceName } from './getSubstrateResourceName';
export const getSubstrateSearchAudienceName = () => {
  const substrateRootPath = getSubstrateResourceName();
  return substrateRootPath ? `${substrateRootPath}/search` : '';
};
